export default "__VITE_ASSET__dcefe7c8__"